export default __webpack_public_path__ + "static/media/Management Consulting.8eca2396.png";